// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../../Api";
import ResponseChecker from "../../Middlewares/ResponseChecker";
import { defaultMessages } from "../../enums/responseMessages.js";

import Endpoints from "../../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## MobileApp.MoneyPoint Get
/**
 *
 * @param {{params: object, query: { paymentMethodId: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(
    Endpoints.MobileApp.MoneyPoint.GetAll(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## MobileApp.MoneyPoint Create
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.MoneyPointRate: number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(
    Endpoints.MobileApp.MoneyPoint.Create(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.MoneyPoint Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(
    Endpoints.MobileApp.MoneyPoint.GetById(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.MoneyPoint Update
/**
 *
 * @param {{ paymentMethodId: string, MobileApp.MoneyPointRate: number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.MobileApp.MoneyPoint.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.MoneyPoint Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.MobileApp.MoneyPoint.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## MobileApp.MoneyPoint Add Money Point For Customers
/**
 *
 * @param {{params: { id: string }, query: object}} form
 
 * @returns
 */
export const AddMoneyPointForCustomers = async (form) => {
  const response = await $api.post(
    Endpoints.MobileApp.MoneyPoint.AddMoneyPointForCustomers(),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
  AddMoneyPointForCustomers,
};
